import { g as l } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as o, openBlock as n, normalizeClass as r, createElementVNode as e } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconClock9",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(i).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = l();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], h = /* @__PURE__ */ e("path", { d: "M6 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM.5 6a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" }, null, -1), p = /* @__PURE__ */ e("path", { d: "M6 2.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H3.75a.5.5 0 0 1 0-1H5.5V3a.5.5 0 0 1 .5-.5Z" }, null, -1), f = [
  h,
  p
], m = ["id"], g = /* @__PURE__ */ e("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), v = [
  g
];
function I(a, b, d, q, C, t) {
  return n(), o("svg", {
    "aria-label": d.ariaLabel,
    class: r([t.iconSizeClass, "d-icon d-icon--clock-9"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Clock 9",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      fill: "currentColor"
    }, f, 8, u),
    e("defs", null, [
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, v, 8, m)
    ])
  ], 10, _);
}
const D = /* @__PURE__ */ s(c, [["render", I]]);
export {
  D as default
};
//# sourceMappingURL=clock-9.js.map
